import { render, staticRenderFns } from "./dEmailField.vue?vue&type=template&id=20eb72d9&"
import script from "./dEmailField.vue?vue&type=script&lang=js&"
export * from "./dEmailField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports